import { ProductLabelInfo } from "src/app/ui/models/domains/pbm/product-management/product-label-info";
import { ProductManagementSearchRequest } from "./product-management-search-request";

export class ProductManagementSearchResult {
  private startIndex: number;
  private endIndex: number;
  private total: number;
  private products: ProductLabelInfo[];
  private request: ProductManagementSearchRequest;

  constructor() {
    this.products = [];
  }

  public getStartIndex(): number {
    return this.startIndex;
  }

  public setStartIndex(value: number): void {
    this.startIndex = value;
  }

  public getEndIndex(): number {
    return this.endIndex;
  }

  public setEndIndex(value: number): void {
    this.endIndex = value;
  }

  public getTotal(): number {
    return this.total;
  }

  public setTotal(value: number): void {
    this.total = value;
  }

  public getProducts(): ProductLabelInfo[] {
    return this.products;
  }

  public setProducts(value: ProductLabelInfo[]): void {
    this.products = value;
  }

  public addProduct(value: ProductLabelInfo): void {
    this.products.push(value);
  }

  public concatProducts(value: ProductLabelInfo[]): void {
    this.products.concat(value);
  }

  public getRequest(): ProductManagementSearchRequest {
    return this.request;
  }

  public setRequest(value: ProductManagementSearchRequest): void {
    this.request = value;
  }
}
